module.exports = {
      id: "how-to-play-usage",
      viewBox: "0 0 296 296",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#how-to-play",
      toString: function () {
        return this.url;
      }
    }